$(document).on("click", ".redchip728_90", function() {
  $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-1-1-11.html");
});

$(document).on("click", ".redchip300_600", function() {
  $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-1-1-13.html");
});

$(document).on("click", ".redchip250_250", function() {
  $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-2-1-16.html");
});

$(document).on("click", ".redchip267_630", function() {
  $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-2-1-17.html");
});

$(document).on("click", ".holdemmanager", function() {
  $(this).attr( "href", "https://holdemmanager.com?a_aid=pokernewb&amp;a_bid=a6deee94");
});

$(document).on("click", ".pokertracker", function() {
  $(this).attr( "href", "https://pokertracker.com/products/PT4/?a_aid=pokernewb&amp;a_bid=2fa70637");
});

$(document).on("click", ".advancedpokertraining", function() {
  $(this).attr( "href", "https://www.advancedpokertraining.com/poker/amember/aff/go/Ovi_Wan");
});
